import React, { useContext } from "react";
import { RouteStatusContext } from "../RouteStatus/context/RouteStatusContext";
import { getPicklistStatusColor } from "../RouteStatus/utils/EntityStatusManager";
import { convertSecondsToTimeFormat } from "../outboundAmzl/util/Util.js";
import { getTimeInSecond } from "../util/Util";
import {
  getPicklistProgress,
  renderWorkGroupIcons,
} from "../RouteStatus/utils/Util";
import { FormattedMessage } from "react-intl";
import Row from "@amzn/meridian/row";
import Link from "@amzn/meridian/link";
import Table, { TableCell, TableRow } from "@amzn/meridian/table";
import Tag from "@amzn/meridian/tag";
import Heading from "@amzn/meridian/heading";
import Text from "@amzn/meridian/text";
import {
  ASSOCIATE,
  AVERAGE_STAGE_DURATION,
  DURATION,
  END_TIME,
  FALLBACK_DASH,
  FALLBACK_ELLIPSIS,
  PICKLIST_TYPE,
  PROGRESS,
  ROUTES,
  START_TIME,
  STATUS,
} from "../RouteStatus/utils/Constants";

const AssociateDetail = (props) => {
  const { viewModel } = useContext(RouteStatusContext);

  const getAssociateRoutes = () => {
    const associateRoutes = [];
    viewModel &&
      viewModel.routeList &&
      viewModel.routeList.forEach((route) => {
        if (route.picklists && route.picklists.length > 0) {
          route.picklists.forEach((picklist) => {
            if (picklist.associates && picklist.associates.length > 0) {
              const associate = picklist.associates.find(
                (assoc) => assoc.alias === props.associate,
              );
              if (associate) {
                associateRoutes.push({
                  routeCode: route.routeCode,
                  status: picklist.status,
                  progress: getPicklistProgress(picklist) || FALLBACK_DASH,
                  duration: associate.pickingDuration
                    ? convertSecondsToTimeFormat(
                        associate.pickingDuration / 1000,
                      )
                    : route.stageDuration,
                  statusTag: getPicklistStatusColor(picklist.status),
                  startTime: route.startTime,
                  endTime: route.endTime,
                  workGroupIcons:
                    renderWorkGroupIcons(picklist) || FALLBACK_DASH,
                });
              }
            }
          });
        }
      });
    return associateRoutes;
  };

  const rowsData = getAssociateRoutes();

  const getAverageStageTime = () => {
    let totalRouteStageTime = 0;
    let count = 0;
    rowsData.forEach((row) => {
      if (row.duration !== FALLBACK_ELLIPSIS) {
        totalRouteStageTime =
          totalRouteStageTime + getTimeInSecond(row.duration);
        count++;
      }
    });
    if (count > 0) {
      const averageStageTimeInSecond = totalRouteStageTime / count;
      return convertSecondsToTimeFormat(averageStageTimeInSecond);
    }
    return 0;
  };
  const getPhoneToolLink = () => {
    const alias = props.associate;
    return "https://phonetool.amazon.com/users/" + alias;
  };
  const renderAssociateMetadata = () => {
    return (
      <Row
        backgroundColor={"secondary"}
        spacingInset="medium"
        spacing={"xlarge"}
      >
        <Row>
          <Text type="h100">
            <FormattedMessage
              id="associate.avergeStageTIme"
              defaultMessage={AVERAGE_STAGE_DURATION}
            />
          </Text>
          <Text type="b200">{getAverageStageTime()} mins</Text>
        </Row>
        <Row>
          <Text type="h100">
            <FormattedMessage
              id="routeInfo.associate"
              defaultMessage={ASSOCIATE}
            />
          </Text>
          <Link
            href={getPhoneToolLink()}
            type="secondary"
            target="_blank"
            rel="noreferrer noopener"
          >
            {props.associate}
          </Link>
        </Row>
      </Row>
    );
  };

  const renderAssociateTable = () => {
    return (
      <Table
        headerRows={1}
        showDividers={true}
        showStripes={true}
        spacing="medium"
      >
        {renderAssociateTableHeader()}
        {renderAssociateRows()}
      </Table>
    );
  };

  const renderAssociateTableHeader = () => {
    return (
      <TableRow>
        <TableCell>
          <FormattedMessage id="associate.route" defaultMessage={ROUTES} />
        </TableCell>
        <TableCell>
          <FormattedMessage id="associate.status" defaultMessage={STATUS} />
        </TableCell>
        <TableCell>
          <FormattedMessage id="associate.progress" defaultMessage={PROGRESS} />
        </TableCell>
        <TableCell>
          <FormattedMessage id="associate.duration" defaultMessage={DURATION} />
        </TableCell>
        <TableCell>
          <FormattedMessage
            id="associate.startTime"
            defaultMessage={START_TIME}
          />
        </TableCell>
        <TableCell>
          <FormattedMessage id="associate.endTime" defaultMessage={END_TIME} />
        </TableCell>
        <TableCell>
          <FormattedMessage
            id="associate.picklistType"
            defaultMessage={PICKLIST_TYPE}
          />
        </TableCell>
      </TableRow>
    );
  };
  const renderAssociateRows = () => {
    return rowsData.map((row) => {
      const primaryKey = row.routeCode;
      return (
        <TableRow key={primaryKey}>
          <TableCell>{primaryKey}</TableCell>
          <TableCell>
            <Tag type={row.statusTag}>{row.status}</Tag>
          </TableCell>
          <TableCell>{row.progress}</TableCell>
          <TableCell>{row.duration}</TableCell>
          <TableCell>{row.startTime}</TableCell>
          <TableCell>{row.endTime}</TableCell>
          <TableCell>{row.workGroupIcons}</TableCell>
        </TableRow>
      );
    });
  };

  return (
    <div>
      <Row widths="100%" spacingInset={"small large small"}>
        <Heading level={3} type="h600" alignment="left">
          {props.associate}
        </Heading>
      </Row>
      <Row widths="100%" spacingInset="small large small">
        {renderAssociateMetadata()}
      </Row>
      <Row widths="100%" spacingInset="small large small">
        {renderAssociateTable()}
      </Row>
    </div>
  );
};

export default AssociateDetail;



// WEBPACK FOOTER //
// ./src/components/associate/AssociateDetail.js